import {gql} from "@irati/utils/gql"

const fragment = gql`
  fragment BusinessProfile on MarketingBusinessProfile {
    businessId
    settings {
      unsubscribedEmail
      unsubscribedPush
    }
  }
`

export default fragment
